import slugify from "../utils/slugify"

import { MATERIALS_CATEGORY_ID, TOOLS_CATEGORY_ID } from "./const"

/**
 * Handle product adaption
 *
 * @param {Array} products
 * @returns
 */
const adaptProducts = products => {
  return products.reduce((acc, current) => {
    const product = {
      id: current.ProductID,
      name: current.ProductName || '',
      description: current.Intro || '',
      image: {
        src: (!!current.ProductImage && !!current.ProductImage[0]) ? current.ProductImage[0] : 'https://via.placeholder.com/180x180?text=Product+Image',
        alt: '',
      },
      categories: current.ProductCategory || [],
      species: current.Species || [],
      therapies: current.TherapyArea || [],
      links: [],
      code: current.ProductCode,
      isMaterial: current.isMaterial,
      materialAmount: current.MaterialAmount,
      metaKeywords: current.MetaKeywords || ""
    }
    if (!current.isMaterial && !current.isTool) {
      product.links.push({
        href: current.PageUrl,
        label: window.vueData.components['card-link'].readMoreLabel || 'Read more',
        icon: {
          src: '../../../../Static/icons/arrow-right-orange-ah.svg',
          description: ''
        }
      })
    }
    if (current.isMaterial) {
      product.categories.push(MATERIALS_CATEGORY_ID)
        if (current.isDownloadable) {
            product.links.push({
                href: current.PageUrl,
                label: window.vueData.components['card-link'].downloadLabel || 'Download',
                icon: {
                    src: '../../../../Static/icons/arrow-right-orange-ah.svg',
                    description: ''
                }
            })
        }
        if (current.isOrderdable && window.vueData.components['cart-drawer'].cart.cartActivated == "True") {
            product.links.push({
                href: current.PageUrl,
                productId: current.ProductID,
                label: window.vueData.components['card-link'].orderLabel || 'Order',
                icon: {
                    src: '../../../../Static/icons/arrow-right-orange-ah.svg',
                    description: ''
                }
            })
        }

    }
    if (current.isTool) {
      product.categories.push(TOOLS_CATEGORY_ID)
      product.links.push({
        href: current.PageUrl,
        label: window.vueData.components['card-link'].readMoreLabel || 'Read more',
        icon: {
          src: '../../../../Static/icons/arrow-right-orange-ah.svg',
          description: ''
        }
      })
    }
    acc.push(product)
    return acc
  }, [])
}

/**
 * Handle filter adaption
 *
 * @param {Array} filters
 * @returns
 */
const adaptFilters = filters => {
  return filters.reduce((acc, current) => {
    acc.push({
      id: current.ID,
      name: current.LocalizedDescription,
      internalName: current.Name,
      slug: slugify(current.LocalizedDescription),
      active: false,
    })
    return acc
  }, [])
}

const adaptCategories = filters => {
  const categories = filters.reduce((acc, current) => {
    acc.push({
      id: current.ID,
      name: current.LocalizedDescription,
      internalName: current.Name,
      slug: slugify(current.LocalizedDescription),
      active: false,
    })
    return acc
    }, [])
    /*
  categories.push({
    id: MATERIALS_CATEGORY_ID,
    name: window.vueData.components.filters.materialsLabel,
    slug: 'materials',
    active: false,
  })
  categories.push({
    id: TOOLS_CATEGORY_ID,
    name: window.vueData.components.filters.toolsLabel,
    slug: 'tools',
    active: false,
    })
    */
  return categories
}

const adaptSpecies = filters => {
  return filters.reduce((acc, current) => {
    acc.push({
      id: current.ID,
      name: current.LocalizedDescription,
      slug: slugify(current.Name),
      active: false,
      internalName: current.Name,
    })
    return acc
  }, [])
}

/**
 * Handle adaption
 *
 * @param {Array} data
 * @param {Function} adapter
 * @returns
 */
const adapt = (data, adapter) => {
  return new Promise((resolve, reject) => {
    try {
      resolve(adapter(data))
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Adapter
 */
const adapter = {
  /**
   * Adapt products
   *
   * @param {Array} products
   * @returns
   */
  products: products => adapt(products, adaptProducts),
  /**
   * Adapt categories
   *
   * @param {Array} categories
   * @returns
   */
  categories: categories => adapt(categories, adaptCategories),
  /**
   * Adapt species
   *
   * @param {Array} species
   * @returns
   */
  species: species => adapt(species, adaptSpecies),
  /**
   * Adapt therapy areas
   *
   * @param {Array} therapies
   * @returns
   */
  therapies: therapies => adapt(therapies, adaptFilters),
}

export default adapter
